var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('article', {
    staticClass: "crm-deal-card",
    class: {
      'is-late': _vm.isLate,
      'is-no-action': _vm.hasNoNextAction,
      'is-won': _vm.oportunidade.status === 'ganha',
      'is-lost': _vm.oportunidade.status === 'perdida',
      'is-draggable': _vm.draggable,
      'is-dragging': _vm.dragging
    },
    attrs: {
      "draggable": _vm.draggable
    },
    on: {
      "dragend": function dragend($event) {
        return _vm.$emit('drag-end', _vm.oportunidade);
      },
      "dragstart": _vm.onDragStart
    }
  }, [_c('button', {
    staticClass: "crm-deal-main",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('open', _vm.oportunidade);
      }
    }
  }, [_c('div', {
    staticClass: "crm-deal-top"
  }, [_c('span', {
    staticClass: "crm-deal-temperature",
    style: _vm.temperatureStyle,
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Alterar temperatura"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('temperature', _vm.oportunidade);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('temperature', _vm.oportunidade);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('temperature', _vm.oportunidade);
      }]
    }
  }, [_c('i', {
    class: _vm.temperatureIcon
  }), _vm._v(" " + _vm._s(_vm.temperatureText) + " ")])]), _c('strong', {
    staticClass: "crm-deal-title"
  }, [_vm._v(_vm._s(_vm.oportunidade.titulo))]), _c('span', {
    staticClass: "crm-deal-contact"
  }, [_vm._v(_vm._s(_vm.contactText))]), _vm.contactPhone ? _c('div', {
    staticClass: "crm-deal-phone"
  }, [_c('i', {
    staticClass: "la la-whatsapp"
  }), _c('span', [_vm._v(" " + _vm._s(_vm.contactPhone) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "crm-deal-next-action"
  }, [_c('i', {
    staticClass: "la la-calendar-check-o"
  }), _c('span', [_vm._v(_vm._s(_vm.nextActionText))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };